import { OnboardingQuestion } from 'common/types'
import {
  IAccountSettingsDrawerGroupItem,
  IAccountSettingsDrawerListItem
} from 'common/types/account-settings-drawer.types'
import { makeAutoObservable } from 'mobx'
import { onboardingStoreState } from 'models/onboarding/onboarding.store'
import { Dispatch, SetStateAction } from 'react'

export enum AccountSettingsGroupItemName {
  EDIT_PROFILE = 'Edit Profile',
  NOTIFICATIONS = 'Notifications',
  SECURITY = 'Security'
}

class AccountSettingsStore {
  linkHierarchy = new Map<AccountSettingsGroupItemName, IAccountSettingsDrawerListItem>([
    [
      AccountSettingsGroupItemName.EDIT_PROFILE,
      {
        id: 1,
        name: AccountSettingsGroupItemName.EDIT_PROFILE,
        url: '/account-settings'
      }
    ],

    [
      AccountSettingsGroupItemName.NOTIFICATIONS,
      {
        id: 2,
        name: AccountSettingsGroupItemName.NOTIFICATIONS,
        url: '/edit-notifications'
      }
    ],

    [
      AccountSettingsGroupItemName.SECURITY,
      {
        id: 3,
        name: AccountSettingsGroupItemName.SECURITY,
        url: '/security'
      }
    ]
  ])

  isOpen = true
  selectedItem: AccountSettingsGroupItemName = AccountSettingsGroupItemName.EDIT_PROFILE
  toggleDrawer() {
    this.isOpen = !this.isOpen
  }
  editProfileQuestions: OnboardingQuestion[]
  fileName: string
  previewImage: string
  avatarUpdated?: boolean
  activeSelection: boolean
  isDrawerOpen = false
  openParents = [true]
  updateButtonEnabled = false
  showConfirmDeleteResume = false
  resumeLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  setFileName = (fileName: string) => {
    this.fileName = fileName
  }
  setResumeLoading = (resumeLoading: boolean) => {
    this.resumeLoading = resumeLoading
  }
  selectItem = (selectedItem: AccountSettingsGroupItemName) => {
    this.selectedItem = selectedItem
  }
  setAvatarUpdated = (avatarUpdated: boolean) => {
    this.avatarUpdated = avatarUpdated
  }
  setActiveSelection = (activeSelection: boolean) => {
    this.activeSelection = this.selectedItem && true
  }
  setIsDrawerOpen = (isDrawerOpen: boolean) => {
    this.isDrawerOpen = isDrawerOpen
  }
  setOpenParents = openParents => {
    this.openParents = openParents
  }
  handleParentClick = index => {
    this.openParents[index] = !this.openParents[index]
  }
  setUpdateButtonEnabled = () => {
    this.updateButtonEnabled = onboardingStoreState.updateButtonEnabled
  }
  setShowConfirmDeleteResume = (show: boolean) => {
    this.showConfirmDeleteResume = show
  }
}

export const accountSettingsStoreState = new AccountSettingsStore()
